export default __webpack_public_path__ + "static/media/svg_logo.6c0c303b.png";